import { render, staticRenderFns } from "./AppRate.vue?vue&type=template&id=fbbe6e06&scoped=true"
import script from "./AppRate.vue?vue&type=script&lang=js"
export * from "./AppRate.vue?vue&type=script&lang=js"
import style0 from "./AppRate.vue?vue&type=style&index=0&id=fbbe6e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbe6e06",
  null
  
)

export default component.exports